export function currentUser() {
  return window.S?.user || null;
}
